module.exports = __webpack_public_path__ + "img/weixin-qr.85c78b01.png";